import React, { useEffect, useState, useContext } from 'react'
import industry3 from '../img/merdekaeditdua.gif'
import { useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import * as yup from 'yup'
import {instance, instance2} from '../utils/axiosInstance'
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import translations from '../login/translations'; // Adjust the path as needed
import { LanguageContext } from '../login/LanguageContext';
import { useToast } from '../login/float';


export default function SendMail() {
    const navigate = useNavigate()
    const location = useLocation();
    const { email } = location.state || {}; // Retrieve email from state

    const { language, toggleLanguage } = useContext(LanguageContext); // Access language and toggle function
    const { showToast } = useToast();

    // If email is not present, redirect back to signup
    useEffect(() => {
      if (!email) {
        navigate('/signup'); // Redirect to Signup if no email is provided
      }
    }, [email, navigate]);
  

    const { values, errors, touched, handleSubmit, handleChange, ...formik } = useFormik({
        initialValues: {
            email:  email || '',
            code: ''
        },
        validationSchema: yup.object({
            email: yup
                .string()
                .required(translations[language].emailEmpty)
                .test('email-validity', translations[language].emailInvalid, (value) => {
                    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
                    return emailRegex.test(value || '')
                }),
                code: yup.string()
        }),
        onSubmit: async (result) => {
            try {
                const response = await instance2.post('verification', result)
                console.log('responseverification1',response)
                console.log('responseverification2',result)
                if(response.status === 'OK'){
                console.log('responseverification',response)
                showToast(translations[language].toastNewMem)
                navigate('/login')
                }else{
                    formik.setErrors({
                        email: translations[language].wrongEmailVerif,
                        code: translations[language].wrongCodeVerif
                    })
                }
            } catch (error) {
                formik.setErrors({
                    email: translations[language].wrongEmailVerif,
                    code: translations[language].wrongCodeVerif
                })
            }
        }
    })

    async function sendEmail(email) {
        try {
          const sendmail = await instance2.post('send-email', {email});
          console.log(sendmail, email);
        } catch (error) {
          console.error('Error sending email:', error);
        }
      }
      const isSubmitDisabled = !values.code || values.code.length === 0;

    return (
        <div className="relative w-full h-screen bg-zinc-600/90">
            <img className="absolute w-full h-full object-cover mix-blend-overlay"  />

            <div className="flex justify-center items-center h-full">
                <form className="max-w-[400px] w-full mx-auto bg-custom-gradient p-8 border border-white rounded-[20px]" noValidate>
                    <img className="flex flex-col items-center px-16" src={industry3} alt="/" />
                    <div className="flex flex-col mb-4">
                        <label>{translations[language].emailLabel}</label>
                        <input
                            className="border relative bg-gray-100 p-2 border border-black rounded-[20px]"
                            type="text"
                            name="email"
                            onChange={handleChange}
                            value={values.email}
                        />
                        <small className="text-red-500">{touched.email && errors.email && errors.email}</small>
                    </div>
                    <div className="flex flex-col ">
                        <label>{translations[language].verificationCodeLabel}</label>
                        <input
                            className="border relative bg-gray-100 p-2 border border-black rounded-[20px]"
                            type="text"
                            name="code"
                            onChange={handleChange}
                            value={values.code}
                        />
                        <small className="text-red-500">{touched.code && errors.code && errors.code}</small>
                    </div>
                    <small className="flex justify-center items-center text-center my-3">{translations[language].checkEmailAndSpam}</small>

                    <button
  className={`relative w-full py-3 mt-8 ${
    isSubmitDisabled ? 'bg-gray-300 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-500'
  } text-white border rounded-[20px]`}
  type="submit"
  onClick={handleSubmit}
  disabled={isSubmitDisabled} // Disables the button when isSubmitDisabled is true
>
{translations[language].verificationLabel}
</button>

                    <div className="flex justify-center items-center text-center my-2">
                    <a
        className="relative justify-center items-center bg-red-500 p-3 text-md rounded-[10px] text-white shadow-lg transition-opacity duration-200"
        href="/"
        onClick={(e) => {
          e.preventDefault(); // Prevent navigation
          sendEmail(values.email); // Call log out function
        }}
      >
        {translations[language].resendVerification}
      </a>
      </div>
                </form>
            </div>
        </div>
    )
}
